<template>
  <CommunityCard class="p-4">
    <h3 class="text-inherit mb-4">Join Requests</h3>
    <ul v-if="joinRequests.length" class="list-style-none">
      <li class="my-2" v-for="req in joinRequests" :key="req.id">
        <div class="invite">
          {{ req.user.first_name + " " + req.user.last_name }}
          <div>
            <button
              :ref="'approve-' + req.id"
              @click="approveJoinRequest(req.id)"
              class="btn btn-outline mx-1 btn-primary"
            >
              Approve
            </button>
            <button
              :ref="'decline-' + req.id"
              @click="declineJoinRequest(req.id)"
              class="btn btn-outline mx-1 btn-danger"
            >
              Decline
            </button>
          </div>
        </div>
      </li>
    </ul>
    <div v-else>
      No join requests for group
    </div>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "./CommunityCard.vue";

export default {
  name: "ForumJoinRequests",
  props: ["joinRequests"],
  components: {
    CommunityCard,
  },
  data() {
    return {
      isSubmitting: false
    }
  },
  methods: {
    approveJoinRequest(requestId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["approve-" + requestId][0];
      btn.innerHTML = "...";

      forumGroupService
        .approveJoinRequest(requestId)
        .then(() => {
          this.$emit("success", "Join request approved");
        })
        .finally(() => {
          this.$emit("reload");
          this.isSubmitting = false;
          btn.innerHTML = "Approve";
        });
    },
    declineJoinRequest(requestId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["decline-" + requestId][0];
      btn.innerHTML = "...";

      forumGroupService
        .declineJoinRequest(requestId)
        .then(() => {
          this.$emit("success", "Join request declined");
        })
        .finally(() => {
          this.$emit("reload");
          this.isSubmitting = false;
          btn.innerHTML = "Decline";
        });
    },
  },
};
</script>

<style scoped>
.invite {
  border: 1px solid #ddd;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
